@if ((activeTransfers$ | async).size > 0) {
	<a
		class="dt-indicator"
		[@slideInUpDown]="animationParams"
		[routerLink]="routerLink">
		<p-progress-spinner
			class="dt-indicator-spinner progress-white"
			[diameter]="40"
			strokeWidth="4" />
		<app-icon
			class="dt-indicator-icon"
			[icon]="['fas', 'arrow-down-arrow-up']"
			iconDisplayBlock />
	</a>
}